export default __webpack_public_path__ + "static/media/folders.03321fb1.png";